import FolderIcon from '@mui/icons-material/Folder';
import LanguageIcon from '@mui/icons-material/Language';
import ArticleIcon from '@mui/icons-material/Article';
import DescriptionIcon from '@mui/icons-material/Description';
import BusinessIcon from '@mui/icons-material/Business';

/**
 * SourceIcon component to display appropriate icon based on source type
 * @param {string} type - The type of source (internal, document, subscription, website, news)
 * @param {string} fontSize - The size of the icon (small, medium, large)
 * @param {string} color - The color of the icon
 * @param {object} props - Additional props to pass to the icon component
 */
const SourceIcon = ({ type, fontSize = 'small', color, ...props }) => {
	// If no specific color is provided, use type-based coloring
	const getColorByType = () => {
		if (color) return color;

		switch (type) {
			case 'internal':
				return 'primary';
			case 'document':
				return 'secondary';
			case 'subscription':
				return 'info';
			case 'website':
				return 'success';
			case 'news':
				return 'warning';
			default:
				return 'default';
		}
	};

	// Select the appropriate icon based on source type
	const renderIcon = () => {
		switch (type) {
			case 'internal':
				return (
					<BusinessIcon
						fontSize={fontSize}
						color={getColorByType()}
						{...props}
					/>
				);
			case 'document':
				return (
					<DescriptionIcon
						fontSize={fontSize}
						color={getColorByType()}
						{...props}
					/>
				);
			case 'subscription':
				return (
					<ArticleIcon
						fontSize={fontSize}
						color={getColorByType()}
						{...props}
					/>
				);
			case 'website':
				return (
					<LanguageIcon
						fontSize={fontSize}
						color={getColorByType()}
						{...props}
					/>
				);
			case 'news':
				return (
					<ArticleIcon
						fontSize={fontSize}
						color={getColorByType()}
						{...props}
					/>
				);
			default:
				return (
					<FolderIcon fontSize={fontSize} color={getColorByType()} {...props} />
				);
		}
	};

	return renderIcon();
};

export default SourceIcon;
